import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import RegisterHook from "../../hook/auth/RegisterHook";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";
import { useTranslation } from "react-i18next";

const RegisterPage = () => {
  const { t } = useTranslation();
  const [
    firstname,
    lastname,
    mobile,
    email,
    password,
    confirmPassword,
    acceptTerms,
    loading,
    onChangeFirstname,
    onChangeLastname,
    onChangeMobile,
    onChangeEmail,
    onChangePassword,
    onChangeConfirmPassword,
    onChangeAcceptTerms,
    onSubmit,
  ] = RegisterHook();
  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  return (
    <Container style={{ minHeight: "670px" }}>
      <Row className="py-5 d-flex justify-content-center hieght-search">
        <Col sm="12" className="d-flex flex-column ">
          <label className="mx-auto title-login">{t("register new account")}</label>
          <input
            value={firstname}
            onChange={onChangeFirstname}
            placeholder={t("first name") + "..."}
            type="text"
            className="user-input my-2 text-center mx-auto"
          />
          {/* <input
            value={lastname}
            onChange={onChangeLastname}
            placeholder="الاسم الاخير..."
            type="text"
            className="user-input my-2 text-center mx-auto"
          /> */}

          <input
            value={email}
            onChange={onChangeEmail}
            placeholder={t("email") + "..."}
            type="email"
            className="user-input my-2 text-center mx-auto"
          />
          <div className="d-flex align-items-center justify-content-center mx-auto my-2 gap-2" style={{ width: "100%", maxWidth: "375px" }}>
            <input
              value="966"
              type="text"
              readOnly
              disabled
              className="user-input text-center"
              style={{ width: "25%", backgroundColor: "#f8f9fa", direction: "ltr" }}
            />
            <input
              value={mobile}
              onChange={onChangeMobile}
              placeholder={t("phone") + "..."}
              type="phone"
              className="user-input text-center"
              style={{ width: "75%" }}
            />
          </div>

          {/* <input
            value={password}
            onChange={onChangePassword}
            placeholder="كلمه السر..."
            type="password"
            className="user-input my-2 text-center mx-auto"
          />
          <input
            value={confirmPassword}
            onChange={onChangeConfirmPassword}
            placeholder="تاكيد كلمة السر ..."
            type="password"
            className="user-input my-2 text-center mx-auto"
          /> */}

          <div className="my-2 text-center mx-auto">
            <input
              type="checkbox"
              checked={acceptTerms}
              onChange={onChangeAcceptTerms}
            />
            <Link
              to={`/terms/${1}`}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              {t("i agree to the terms")}
            </Link>
          </div>

          <button
            onClick={onSubmit}
            className="btn-login mx-auto mt-4"
            style={{ backgroundColor: settingsRes?.data?.primaryColor }}
            disabled={!loading}
          >
            {
              !loading ? <LoadingSpinner /> : t("register account")
            }

          </button>
          <label className="mx-auto my-4">
            {t("already have an account")}
            <Link to="/login" style={{ textDecoration: "none" }}>
              <span style={{ cursor: "pointer" }} className="text-danger">
                {t("click here")}
              </span>
            </Link>
          </label>
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default RegisterPage;
